import axios from 'axios';
import { MEALDEAL } from '../index';

export const getMealDealApi = (postData) => {
  return axios.post(MEALDEAL, JSON.stringify(postData));
};
